// Shared constants for the notification system (safe to import from client + server).
export const NOTIFICATION_TYPES = [
  "daily_checkin",
  "hrt_reminder",
  "weekly_review",
  "milestone",
] as const;

export type NotificationType = (typeof NOTIFICATION_TYPES)[number];

// Default local-time-of-day per type when the user has not set a custom_time.
export const DEFAULT_TIMES: Record<NotificationType, string> = {
  daily_checkin: "20:00",
  hrt_reminder: "20:00", // overridden by HRT schedule (Morning => 08:00)
  weekly_review: "09:00", // Sundays only
  milestone: "00:00", // event-driven; time unused
};

// Public VAPID key — safe to embed in client code.
// (Mirrors the VAPID_PUBLIC_KEY secret. If you rotate the secret, update this too.)
export const VAPID_PUBLIC_KEY =
  "BCEsvr4rpAZgfC-N4tS1hLGYBzB-jgnfLCwh5SbfOKXmnUOWzo1N5ckBNlUbPMFUERTzUvUc1YwQtztdzXSxLFk";

// Build marker — bump to force a fresh worker deploy when secrets rotate.
export const BUILD_MARKER = "2026-06-11T-vapid-rotate";


